const apiUrl = "https://localhost:5001";
export { apiUrl };
